import React from 'react';

const SkipLinks = () => (
  <ul className="hd-skipLinks">
    <li>
      <a href="#main-navigation">
        Skip to main navigation
      </a>
    </li>
    <li>
      <a href="#main-content">
        Skip to content
      </a>
    </li>
    <li>
      <a href="#mini-trolley">
        Skip to trolley
      </a>
    </li>
    <li>
      <a href="#search">
        Skip to search
      </a>
    </li>
  </ul>
);

export default SkipLinks;
